import { AdminData } from '../types';

export const mockData: AdminData[] = [];
